/* tslint:disable */
/* eslint-disable */
/**
 * Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigninRequest
 */
export interface SigninRequest {
    /**
     * 
     * @type {string}
     * @memberof SigninRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SigninRequest
     */
    password: string;
}

/**
 * Check if a given object implements the SigninRequest interface.
 */
export function instanceOfSigninRequest(value: object): value is SigninRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function SigninRequestFromJSON(json: any): SigninRequest {
    return SigninRequestFromJSONTyped(json, false);
}

export function SigninRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigninRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function SigninRequestToJSON(value?: SigninRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

